import { RouteConfig } from './types';
import type { RoleResolverContext } from './resolveRole';
import { rideshareRoutes } from '@portals/rideshareRoutes';
import { rideshareFullRoutes } from '@portals/rideshareFullRoutes';
import { contractorPortalRoutes } from '@portals/contractorPortalRoutes';
import { payerPortalRoutes } from '@portals/payerPortalRoutes';
import { memberPortalRoutes } from '@portals/memberPortalRoutes';
import { CONTRACTOR_USER, MOBILE_USER, WEB_USER } from '@routes/helpers';
import { APP_VERSION } from '@utils/constants';

type RouteSource =
  | RouteConfig[]
  | ((config: RoleResolverContext) => RouteConfig[]);

export const routesByRole: Record<string, RouteSource> = {
  WEB_USER: APP_VERSION === 'full' ? rideshareFullRoutes : rideshareRoutes,
  CONTRACTOR_USER: contractorPortalRoutes,
  payerPortal: payerPortalRoutes,
  memberPortal: memberPortalRoutes,
  MOBILE_USER: memberPortalRoutes,
};

export const resolveRoutesForRole = (
  role:
    | typeof WEB_USER
    | typeof CONTRACTOR_USER
    | typeof MOBILE_USER
    | 'payerPortal'
    | 'memberPortal',
  ctx: RoleResolverContext
): RouteConfig[] => {
  const source = routesByRole[role];
  if (!source) return [];
  return typeof source === 'function' ? source(ctx) : source;
};
